import { render, staticRenderFns } from "./JSelectPosition.vue?vue&type=template&id=5bfbee95&scoped=true&"
import script from "./JSelectPosition.vue?vue&type=script&lang=js&"
export * from "./JSelectPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfbee95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bfbee95')) {
      api.createRecord('5bfbee95', component.options)
    } else {
      api.reload('5bfbee95', component.options)
    }
    module.hot.accept("./JSelectPosition.vue?vue&type=template&id=5bfbee95&scoped=true&", function () {
      api.rerender('5bfbee95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecgbiz/JSelectPosition.vue"
export default component.exports